import {
  alpha,
  Box,
  Breadcrumbs,
  Link,
  Skeleton,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BackButton from '../../../../InstallFacilities/BackButton';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import _ from 'lodash';
import { NormalizedGroup } from '../../../../../../redux/structure/GroupsAdapter';
import SubHeaderEntityActions from './SubHeaderEntityActions/SubHeaderEntityActions';
import WorkspaceAPI from '../../../../../../redux/workspace/WorkspaceAPI';
import { skipToken } from '@reduxjs/toolkit/query';
interface SubHeaderLocationsProps {
  entity?: NormalizedGroup;
  marketId: string | undefined;
  pathGroups: NormalizedGroup[];
  loading?: boolean;
  type: string;
}
export function SubHeaderLocations(props: SubHeaderLocationsProps) {
  const { entity, type, pathGroups, loading: loadingProp, marketId } = props;
  const { t } = useTranslation();
  const { data: workspace, isLoading: loadingWorkspace } =
    WorkspaceAPI.useGetWorkspaceByIdQuery(marketId ?? skipToken);
  const loading = loadingProp || loadingWorkspace;
  const lastGroup = _.nth(pathGroups, -2);
  const urlGoBack = !marketId
    ? lastGroup
      ? `/manager/view-locations/${lastGroup?.uuid}`
      : '/manager/view-locations'
    : lastGroup
    ? `/markets/${marketId}/view-locations/${lastGroup?.uuid}`
    : pathGroups.length === 1
    ? `/markets/${marketId}/view-locations`
    : `/markets`;

  const breadcrumbs = !marketId
    ? [
        <Link
          underline="hover"
          key="1"
          color="inherit"
          href="/manager/view-locations"
        >
          {t('device.menu.overview')}
        </Link>,
        pathGroups.map((group, i) =>
          i === pathGroups.length - 1 ? (
            <Typography key={group.id} sx={{ color: 'text.primary' }}>
              {group.name}
            </Typography>
          ) : (
            <Link
              underline="hover"
              key={group.id}
              color="inherit"
              href={`/manager/view-locations/${group.uuid}`}
            >
              {group.name}
            </Link>
          )
        ),
      ]
    : [
        <Link underline="hover" key="1" color="inherit" href="/markets">
          {t('view_locations.view_all')}
        </Link>,
        pathGroups.length === 0 ? (
          <Typography key={workspace?.id} sx={{ color: 'text.primary' }}>
            {workspace?.name}
          </Typography>
        ) : (
          <Link
            underline="hover"
            key={workspace?.id}
            color="inherit"
            href={`/markets/${workspace?.id}/view-locations`}
          >
            {workspace?.name}
          </Link>
        ),
        pathGroups.map((group, i) =>
          i === pathGroups.length - 1 ? (
            <Typography key={group.id} sx={{ color: 'text.primary' }}>
              {group.name}
            </Typography>
          ) : (
            <Link
              underline="hover"
              key={group.id}
              color="inherit"
              href={`/markets/${workspace?.id}/view-locations/${group.uuid}`}
            >
              {group.name}
            </Link>
          )
        ),
      ];

  return (
    <StyledSubHeader>
      <Stack
        px={2}
        py={1}
        alignItems={'center'}
        spacing={4}
        direction={'row'}
        flex={'1 1 auto'}
      >
        <BackButton sx={{ width: '6rem' }} loading={loading} href={urlGoBack} />
        {loading ? (
          <Skeleton variant="text" width={200} />
        ) : (
          <Typography variant="body1">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Typography>
        )}
      </Stack>
      <Box>
        <SubHeaderEntityActions
          entity={entity}
          type={type}
          marketId={marketId}
        />
      </Box>
    </StyledSubHeader>
  );
}

const StyledSubHeader = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.4),
  width: '100%',
  padding: theme.spacing(1),
  color: theme.palette.primary.contrastText,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
